import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const CreateTodoEvent = declareEvent('create-todo', {
  title: string(),
});
export type CreateTodoEvent = TypeOfEvent<typeof CreateTodoEvent>;
